import { render, staticRenderFns } from "./IndexBewaren.vue?vue&type=template&id=f488a79e&"
import script from "./IndexBewaren.vue?vue&type=script&lang=js&"
export * from "./IndexBewaren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports